import React from "react";
import { Col, 
		InputGroup,
  		InputGroupAddon,
  		FormSelect ,
  		InputGroupText
	} from "shards-react";
import { store, view } from 'react-easy-state';
import PropTypes from 'prop-types'; 
import introducer_list  from './IntroducerStore';
import getArray from './getArray';


export default view((props)=>{     
                                  var data = getArray(introducer_list.list);
                                  var isLoading = introducer_list.isLoading;
                                  var exists = introducer_list.hasData;
                                  console.log(data);

                                  return <SelectIntroducer data={data} 
                                                   	  isLoading={isLoading}
                                                   	  exists = {exists}
                                                   	  onChange = {props.onChange}
                                                  
                                          />
                      });

class SelectIntroducer extends React.Component{

	componentDidMount(){
			console.log("Running GetIntroducersNames");
      introducer_list.getList();
	}


  render(){

      var arr  = this.props.data;
     

    return (
    
      <InputGroup className="mb-3">
                
     <FormSelect onChange ={this.props.onChange}>
        <option value={null}>{this.props.isLoading?"Loading...":(this.props.exists?"Choose Introducer":"No Introducer")}</option>
        <option value={"None"}>None</option>
        {

               arr.map((item,i)=>{
                         return (<option key={i} value={item.int_id}>{item.int_id+" ("+item.name+")"}</option>)
                })
              
        } 
        

      </FormSelect>
     
      <InputGroupAddon type="prepend">
                    <InputGroupText>Int</InputGroupText>
      </InputGroupAddon>
    </InputGroup>
  )
  }
}

